// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2uudk","name":"ConsentHeader_name__2E_fn","birthday":"ConsentHeader_birthday__1E_0l","skeleton":"ConsentHeader_skeleton__2UTGK"};